<script>
  import dayjs from "dayjs";
  import GeneralPanelButton from "../button/GeneralPanelButton.svelte";
  import { translate } from "../../i18n/i18next";
  import GeneralSelect from "../select/GeneralSelect.svelte";
  import SyncBorderGroup from "./SyncBorderGroup.svelte"
  import { saveResultGraphConfiguration } from "../../utils/configurationStorage/views/ResultGraphConfigurationStorage";

  import {
    DisplayMode,
    monthColumns,
    resultColumnLength,
    resultColumnTotal,
    ResultDialogVisible,
    resultStartColumn,
    selectedDisplayMode
  } from "./ResultGraphStore"
  import MenuBar from "../menuBar/MenuBar.svelte";
  import MenuBarItem from "../menuBar/MenuBarItem.svelte";

  const onClickResultDialogOpen = () => { ResultDialogVisible.set(true); };

    const ScrollMonthColumns = (delta) => {
        resultStartColumn.update((n) => 
            Math.max(0, Math.min($resultColumnTotal - $resultColumnLength, n + delta))
        );
        saveResultGraphConfiguration({"resultStartColumn": $resultStartColumn}, 'default', 'default');
    }

    const MoveButton_Home = () => {
        MoveButton_PrevPage();
    }

    const MoveButton_PrevPage = () => {
        ScrollMonthColumns(-100);
    }

    // set start month to this month
    const MoveButton_Today = () => {
        const thisMonth = dayjs().format('M' + '月');
        const thisMonthIndex = $monthColumns.indexOf(thisMonth);
        if(thisMonthIndex >= 0){
            ScrollMonthColumns(thisMonthIndex - $resultStartColumn);
        }
    }

    const MoveButton_Prev = () => {
        ScrollMonthColumns(-1);
    }

    const MoveButton_Next = () => {
        ScrollMonthColumns(1);
    }

    const MoveButton_NextPage = () => {
        ScrollMonthColumns(100);
    }

    $: console.log("selectedDisplayMode", $selectedDisplayMode);
</script>

<MenuBar onClickDetailedMenuOpen={onClickResultDialogOpen}>
  <svelte:fragment slot="settings">
    <MenuBarItem>
      <GeneralSelect
        bind:value={$selectedDisplayMode}
        options={$DisplayMode}
        onChangeEvent={() => saveResultGraphConfiguration({"selectedDisplayMode": $selectedDisplayMode}, 'default', 'default')}
      />
    </MenuBarItem>
    <MenuBarItem>
      <SyncBorderGroup/>
    </MenuBarItem>
  </svelte:fragment>
  <GeneralPanelButton
    slot="pagination"
    items={[
      {
        buttonText: translate("generic.startShort"),
        buttonFunction: MoveButton_Home,
      },
      {
        buttonImage: '/assets/Pager_FL.svg',
        buttonFunction: MoveButton_PrevPage,
      },
      {
        buttonImage: '/assets/Pager_L.svg',
        buttonFunction: MoveButton_Prev,
      },
      {
        buttonText: translate("generic.today"),
        buttonFunction: MoveButton_Today,
      },
      {
        buttonImage: '/assets/Pager_R.svg',
        buttonFunction: MoveButton_Next,
      },
      {
        buttonImage: '/assets/Pager_FR.svg',
        buttonFunction: MoveButton_NextPage,
      },
    ]}
  />
</MenuBar>
